import React from "react";

export const BackgroundParticles = React.memo(() => {
  const particles = Array.from({ length: 15 }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 5,
    duration: 10 + Math.random() * 10,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0 opacity-20">
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute bg-white/10 rounded-full blur-sm animate-[floatUp_linear_infinite]"
          style={{
            left: `${p.left}%`,
            width: "4px",
            height: "4px",
            bottom: "-10px",
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
      <style>{`
                @keyframes floatUp {
                    0% { transform: translateY(0) rotate(0deg); opacity: 0; }
                    20% { opacity: 1; }
                    80% { opacity: 1; }
                    100% { transform: translateY(-100vh) rotate(360deg); opacity: 0; }
                }
            `}</style>
    </div>
  );
});
